<template>
  <h2 class="heading-2 mb-8">
    {{ i18n(translations.title) }}
  </h2>

  <RevTag class="mb-8" :label="i18n(translations.waived)" variant="success" />

  <div class="body-1 mb-16">
    {{ i18n(translations.subtitle) }}
  </div>

  <RevButton variant="secondary" @click="$emit('edit')">
    {{ i18n(translations.edit) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevTag } from '@ds/components/Tag'

import translations from './WaivedBlockContent.translations'

const i18n = useI18n()

defineEmits<{
  edit: []
}>()
</script>
